/* eslint-disable max-lines */
export default class FilterUtils {
  /* Función para obtener el mapa de un array que se le pase en el cual todos sus
    elementos sean objetos y presenten un atributo que sea el id */
  static getMap(array) {
    const map = new Map();
    array?.forEach(element => {
      map.set(element.id, element);
    });

    return map;
  }

  static getUndoChangesMap(keys, map) {
    keys.forEach(key => {
      let changed = map.get(key);
      changed.selected = !changed.selected;
      map.set(key, changed);
    });

    return map;
  }

  static compareFilters(list1, list2) {
    let listModify = [];
    for (let i = 0; i < list1.length; i++) {
      const element = JSON.parse(JSON.stringify(list1[i]));
      element.selected = false;
      listModify.push(element as never);
    }

    let list2Copy = JSON.parse(JSON.stringify(list2));

    for (let i = 0; i < list2Copy.length; i++) {
      /* Comprueba si está presente el mismo objeto en la primera lista de filtros  */
      const index = listModify.findIndex(
        element => JSON.stringify(element) === JSON.stringify(list2Copy[i]),
      );

      let elementFromList1AndList2 = list1.find(
        (element: any) => String(element.id) === String(list2Copy[i].id),
      );

      /* Comprueba que si el elemento no se ha encontrado se ha modficado */
      if (index === -1 && elementFromList1AndList2) {
        if (elementFromList1AndList2.selected !== undefined) {
          list2Copy[i].selected = elementFromList1AndList2.selected;
        }
      } else if (index !== -1 && elementFromList1AndList2) {
        list2Copy[i] = elementFromList1AndList2;
      }
    }
    return list2Copy;
  }

  /**
   * @function equalsLists comprueba que dos listas de elementos son iguales
   */
  static equalsLists(list1: Array<any>, list2: Array<any>) {
    if (
      (list1.length === 0 && list2.length !== 0) ||
      (list1.length !== 0 && list2.length === 0)
    ) {
      return false;
    }

    for (const element1 of list1) {
      let exists = list2.find(
        (element: any) => JSON.stringify(element) === JSON.stringify(element1),
      );
      if (!exists) {
        return false;
      }
    }

    for (const element2 of list2) {
      let exists = list1.find(
        (element: any) => JSON.stringify(element) === JSON.stringify(element2),
      );
      if (!exists) {
        return false;
      }
    }

    return true;
  }

  static compareAgencies(list1, list2) {
    let listModify = [];

    for (let i = 0; i < list1.length; i++) {
      let agencies = [];
      for (let j = 0; j < list1[i].agencies.length; j++) {
        let agencyString = JSON.stringify(list1[i].agencies[j]);
        let agency = JSON.parse(agencyString);
        agency.selected = false;
        agencies.push(agency as never);
      }
      let modeString = JSON.stringify(list1[i]);
      let mode = JSON.parse(modeString);
      mode.agencies = agencies;
      listModify.push(mode as never);
    }

    for (let i = 0; i < list2.length; i++) {
      /* Comprueba si está presente el mismo objeto en la primera lista de filtros  */
      const index = listModify.findIndex(
        element => JSON.stringify(element) === JSON.stringify(list2[i]),
      );

      /* Comprueba que si el elemento no se ha encontrado se ha modificado */
      let elementFromList2InList1 = list1.find(
        (element: any) => String(element.id) === String(list2[i].id),
      );

      if (index === -1 && elementFromList2InList1) {
        list2[i].agencies.forEach((agency: any) => {
          let modeString = JSON.stringify(elementFromList2InList1);
          let modeList1 = JSON.parse(modeString);
          let indexAgency = modeList1.agencies.findIndex(
            (element: any) => element.id === agency.id,
          );
          if (indexAgency !== -1) {
            agency.selected = modeList1.agencies[indexAgency].selected;
          }
          return agency;
        });
      } else if (index !== -1) {
        list2[i] = elementFromList2InList1;
      }
    }
    return list2;
  }

  static compareAgenciesFilters(list1, list2) {
    const mapList1 = this.getMap(list1);
    let listModify = [];

    for (let i = 0; i < list1.length; i++) {
      let agencies = [];
      for (let j = 0; j < list1[i].agencies.length; j++) {
        let agencyString = JSON.stringify(list1[i].agencies[j]);
        let agency = JSON.parse(agencyString);
        agency.selected = false;
        agencies.push(agency as never);
      }
      let modeString = JSON.stringify(list1[i]);
      let mode = JSON.parse(modeString);
      mode.agencies = agencies;
      listModify.push(mode as never);
    }

    for (let i = 0; i < list2.length; i++) {
      /* Comprueba si está presente el mismo objeto en la primera lista de filtros  */
      const index = listModify.findIndex(
        element => JSON.stringify(element) === JSON.stringify(list2[i]),
      );

      /* Comprueba que si el elemento no se ha encontrado se ha modificado */
      if (index === -1 && mapList1.get(list2[i].id) !== undefined) {
        list2[i].agencies.forEach(agency => {
          let modeString = JSON.stringify(mapList1.get(list2[i].id));
          let modeList1 = JSON.parse(modeString);
          let indexAgency = modeList1.agencies.findIndex(
            element => element.id === agency.id,
          );
          if (indexAgency !== -1) {
            agency.selected = modeList1.agencies[indexAgency].selected;
          }
          return agency;
        });
      } else if (index !== -1) {
        list2[i] = mapList1.get(list2[i].id);
      }
    }
    return list2;
  }

  /* devuelve todas las agencias que estén seleccionadas para ser filtradas */
  static getFilteredAgencies(modes) {
    let results = [];
    if (!modes) {
      return;
    }
    for (let i = 0; i < modes.length; i++) {
      let agencies = modes[i].agencies;
      for (let j = 0; j < agencies?.length; j++) {
        if (agencies[j].id !== 0 && agencies[j].selected) {
          results.push(agencies[j].id as never) ;
        }
      }
    }
    return results;
  }

  /**
   * @params
   */

  static stopsByAgencies(stops, filteredAgencies) {
    if (filteredAgencies?.length === 0) {
      return stops;
    }
    return stops?.filter(
      stop =>
        filteredAgencies?.findIndex(
          agency => String(agency) === String(stop.agencyOriginId),
        ) !== -1,
    );
  }

  /* Función para combinar los valores del caso de agency y dataorigin */
  static combineValues(agencies, dataOrigin) {
    return agencies.map((element: any) => {
      let agency = JSON.parse(JSON.stringify(element));
      let origin = dataOrigin.findIndex(
        (data: any) => String(data.agencyId) === String(agency.id),
      );
      if (origin !== -1) {
        if (dataOrigin[origin].transportModes.length > 0) {
          agency.agencyOriginId = dataOrigin[origin].id;
          agency.mode = dataOrigin[origin].transportModes[0].transportModeId;
          agency.icons = dataOrigin[origin].transportModes[0];
          agency.transportModes = dataOrigin[origin].transportModes;
        }
      } else {
        agency.icons = null;
      }
      return agency;
    });
  }

  /* Función que obtiene las stops que se encuentran en una región determinada del mapa */
  static stopsByRegion(zoom, region, stops) {
    let filtered = [];
    if (zoom > 14 && stops && stops?.length > 0) {
      filtered = JSON.parse(JSON.stringify(Array.from(stops))).filter(
        ({stopLat, stopLon}) =>
          region._northEast?.lat > stopLat &&
          region._southWest?.lat < stopLat &&
          region._northEast?.lng > stopLon &&
          region._southWest?.lng < stopLon,
      );
    }

    return filtered;
  }

  /* Función que obtiene los pois que se encuentran en una región determinada */
  static poisByRegion(zoom, pois, region) {
    let filtered = [];
    if (!region || region?.northEast?.latitude === 0) {
      return filtered;
    }
    if (zoom >= 15 && pois && pois?.length > 0) {
      filtered = JSON.parse(JSON.stringify(Array.from(pois))).filter(
        ({latitude, longitude}) =>
          region.northEast.latitude > latitude &&
          region.southWest.latitude < latitude &&
          region.northEast.longitude > longitude &&
          region.southWest.longitude < longitude,
      );
    }

    return filtered;
  }

  static clusterizedMarkers(markers: Array<any>, zoom: number) {
    let filtered: Array<any> = [...markers];

    if (zoom > 12.5 && filtered.length > 0) {
      let differences: Array<any> = [];
      for (let i = 0; i < filtered.length; i++) {
        let neighboursMarkerI: Array<any> = [];
        /* Se recorren todos los marcadores diltrados */
        for (let j = 0; j < filtered.length; j++) {
          if (j !== i) {
            /* Se calcula la distancia Euclídea para cada punto */
            let distanceLat = Math.pow(
              filtered[i]?.location?.latitude - filtered[j]?.location?.latitude,
              2,
            );
            let distanceLon = Math.pow(
              filtered[i]?.location?.longitude -
                filtered[j]?.location?.longitude,
              2,
            );
            let valueDistance = Math.pow(distanceLat + distanceLon, 0.5);
            /* En caso de ser una distancia muy pequeña se guarda el elemento en la lista de vecinos */
            if (valueDistance < 0.0001) {
              neighboursMarkerI.push({
                ...filtered[j],
              });
            }
          }
          /* Si la lista de vecinos contiene alguno se introduce al propio marcador
          con el que se estaba comparando */
          if (neighboursMarkerI.length > 0) {
            neighboursMarkerI = [filtered[j]].concat(neighboursMarkerI);
          }
          differences.push(neighboursMarkerI);
        }
      }

      let elementsClustered: Array<any> = [];
      /* Se recorre el array de todos los arrays de vecinos
      y se comprueba cuales tienen elementos y no se encuentran ya
      calculados sus nuevas localizaciones a partir del cluster formado */
      for (let i = 0; i < differences.length; i++) {
        if (differences[i].length > 0) {
          if (
            !elementsClustered.find(
              (element: any) =>
                String(element.id) === String(differences[i][0].id),
            )
          ) {
            let cluster: Array<any> = differences[i];
            /* Se recorre el cluster de vecinos */
            for (let j = 0; j < cluster.length; j++) {
              let randomNumberLat = Math.random() * 0.00045 + 0.00025;
              let randomNumberLon = Math.random() * 0.00045 + 0.00025;
              randomNumberLat =
                Math.random() < 0.5 ? -randomNumberLat : randomNumberLat;
              randomNumberLon =
                Math.random() < 0.5 ? -randomNumberLon : randomNumberLon;
              let changedMarker = {...cluster[j]};
              /* Para el caso del último se deja en la posición inicial y para los demás
              se calcula de forma aleatoria una posición nueva cerca entre 0.00045 y 0.00025
              de latitud o longitud */
              if (j === cluster.length - 1) {
                if (
              /* eslint-disable max-lines */
                  !elementsClustered.find(
                    (element: any) =>
                      String(element.id) === String(changedMarker.id),
                  )
                ) {
                  elementsClustered.push(changedMarker);
                  let indexToDelete: number = filtered.findIndex(
                    (element: any) =>
                      String(element.id) === String(changedMarker.id),
                  );
                  filtered.splice(indexToDelete, 1, changedMarker);
                }
              } else {
                changedMarker.location.latitude =
                  parseFloat(String(changedMarker.location.latitude)) +
                  randomNumberLat;

                changedMarker.longitude =
                  parseFloat(String(changedMarker.location.longitude)) +
                  randomNumberLon;
                if (
                  !elementsClustered.find(
                    (element: any) =>
                      String(element.id) === String(changedMarker.id),
                  )
                ) {
                  elementsClustered.push(changedMarker);
                  let indexToDelete: number = filtered.findIndex(
                    (element: any) =>
                      String(element.id) === String(changedMarker.id),
                  );
                  filtered.splice(indexToDelete, 1, changedMarker);
                }
              }
            }
          }
        }
      }
    }

    return filtered;
  }

  static poisByCategory(categories: Array<any>, pois: Array<any>) {
    let filtered = [] as Array<any>;
    if (categories && pois && pois?.length > 0) {
      if (categories?.length > 0) {
        let selectedCategories: Array<any> = Array.from(categories).filter(
          (category: any) => category?.selected === true,
        );
        if (selectedCategories.length === 0) {
          return pois;
        }
        filtered = Array.from(pois).filter(
          poi =>
            Array.from(selectedCategories).findIndex(
              category => String(category.id) === String(poi.categoryId),
            ) !== -1,
        );
      } else {
        return pois;
      }
    }
    return filtered;
  }

  static stopsByModeTransport(modes, stops) {
    let filtered = [];
    if (modes && stops && stops?.length > 0) {
      let arrayModes = Array.from(modes);
      let selectedmodes = arrayModes.filter(category => {
        const { selected } = category as any;
        return selected;
      });
      if (selectedmodes.length === 0) {
        return stops;
      }
      filtered = stops.filter(
        stop => selectedmodes.findIndex(mode => {
          const { id } = mode as any;
          return id === stop.mode;
        }) !== -1,
      );
    }
    return filtered;
  }

  static stopsByTransportFavorite(modes: Array<any>, stops: Array<any>) {
    let filtered : Array<any> = [];
    if (modes && stops && stops?.length > 0) {
      filtered = stops.filter(
        stop =>
          modes.findIndex(
            (mode: any) => String(mode) === String(stop.agencyOriginId),
          ) !== -1,
      );
    }
    return filtered;
  }

  static calculateRegion(lat1, lon1, lat2, lon2) {
    const R = 6371e3; // metres
    const φ1 = (lat1 * Math.PI) / 180; // φ, λ in radians
    const φ2 = (lat2 * Math.PI) / 180;
    const Δφ = ((lat2 - lat1) * Math.PI) / 180;
    const Δλ = ((lon2 - lon1) * Math.PI) / 180;

    const a =
      Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c; // in metres
    return d;
  }

  static getStopFavorites(stops, favorites) {
    stops.forEach(stop => {
      let index = favorites?.findIndex(
        favorite => `${favorite}` === `${stop.id}`,
      );
      if (index !== -1) {
        if (stop.alert) {
          stop.markerIcon = stop.icons?.iconMarkFavAlertId;
        } else {
          stop.markerIcon = stop.icons?.iconMarkFavTransportId;
        }
        stop.isFavorite = true;
      }
    });
  }

  static getPoisFavorites(pois, favorites) {
    pois.forEach(poi => {
      let index = favorites?.findIndex(
        favorite => `${favorite}` === `${poi.id}`,
      );
      if (index !== -1) {
        poi.markerIcon = poi.markerFavorite;
        poi.isFavorite = true;
      }
    });
  }

  /**
   *
   * @param {*} stops se trata de un array de paradas
   * @param {*} alerts se trata de un array de alert cards
   * Busca que stops tienen que su agencia presente alguna alerta
   * y esta alerta coincida con su stopId
   */
  static getStopsWithAlerts(stops, alerts) {
    stops.forEach((stop: any) => {
      for (let i = 0; i < alerts.length; i++) {
        let alertsOfStops = alerts[i]?.stops?.filter(
          (alertStop: any) =>
            String(alertStop.stop.idParada) === String(stop.id),
        );

        if (alertsOfStops?.length > 0 && !stop.alert) {
          stop.alert = alertsOfStops;
        } else if (alertsOfStops?.length > 0 && stop.alert) {
          stop.alert = alertsOfStops.concat(stop.alert);
        }
      }
    });
  }

  static checkAlert(stop, alerts) {
    let hasAlert = false;
    for (let i = 0; i < alerts?.length; i++) {
      let alertStopFound = alerts[i]?.stops?.find(
        (alertStop: any) => String(alertStop.stop.idParada) === String(stop.id),
      );
      if (alertStopFound) {
        hasAlert = true;
      }
    }

    return hasAlert;
  }

  static checkLineAlerts(line, alerts) {
    for (let i = 0; i < alerts?.length; i++) {
      let alertsOfLine: Array<any> = alerts[i]?.lines?.filter(
        (alertLine: any) =>
          String(alertLine.line.idLinea) === String(line.lineId) &&
          String(alertLine.line.tripId) === String(line.tripId),
      );
      if (alertsOfLine.length > 0) {
        line.alert = alertsOfLine;
      }
    }
  }

  static checkFavorite(item: any, favorites: any) {
    let isFav = false;
    switch (item?.markerType) {
      //en el caso de las direcciones se comprueba que el nombre no sea el mismo
      //porque al obtener una dirección no se tiene ningún id
      case 'direction':
        let indexDir: number = favorites.directions.findIndex(
          (element: any) => element.direction === item.address,
        );
        isFav = indexDir !== -1;
        break;
      case 'poi':
        let indexPoi: number = favorites.pois.findIndex(
          (element: any) => String(element) === String(item.id),
        );
        isFav = indexPoi !== -1;
        break;
      case 'stop':
        let indexStop: number = favorites.stops.findIndex(
          (element: any) => String(element) === String(item.id),
        );
        isFav = indexStop !== -1;
        break;
      default:
        break;
    }
    return isFav;
  }
}
